import { useEffect } from "react";
import {
  useSEOMeta,
  generateOrganizationSchema,
  generateWebPageSchema,
} from "@/components/SEO";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import StatsSection from "./components/StatsSection";
import ProjectsSection from "./components/ProjectsSection";
import DonationSection from "./components/DonationSection";
import ArticlesSection from "./components/ArticlesSection";
import Footer from "./components/Footer";

export default function Home() {
  useSEOMeta({
    title:
      "BHODEV Cameroon - Bogi Health Organization for Development | Community Health NGO",
    description:
      "BHODEV Cameroon is an NGO promoting health, peace, social justice and sustainable development in Cameroon since 2014. Serving vulnerable communities in Buea, North West and South West regions.",
    keywords:
      "BHODEV, Cameroon NGO, community health, sustainable development, Buea NGO, humanitarian Cameroon, displaced people, health NGO, education NGO, women empowerment, economic security, GBV prevention, Cameroon charity",
    canonicalUrl: "https://bhodevcameroon.org/",
    ogImage:
      "https://readdy.ai/api/search-image?query=BHODEV%20NGO%20team%20working%20in%20Cameroon%20community%20health%20outreach%20wide%20landscape%20warm%20natural%20light%20green%20landscape%20documentary%20photography%20professional%20humanitarian%20work&width=1200&height=630&seq=home-og&orientation=landscape",
    schemaData: {
      ...generateOrganizationSchema(),
      ...generateWebPageSchema(
        "BHODEV Cameroon - Bogi Health Organization for Development",
        "BHODEV Cameroon is an NGO promoting health, peace, social justice and sustainable development in Cameroon since 2014.",
        "https://bhodevcameroon.org/"
      ),
    },
  });

  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, []);

  return (
    <main className="font-inter bg-white">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <StatsSection />
      <ProjectsSection />
      <DonationSection />
      <ArticlesSection />
      <Footer />
    </main>
  );
}